/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Spaces_DescriptionInputs */



/**
* | output |
* | --- |
* | "Pick what the agent may read and use. When it runs on its own or in your personal chats, it works with exactly that. In a project chat, your picks are added ..." |
*
* @param {Agent_Builder_Spaces_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_spaces_description = /** @type {((inputs?: Agent_Builder_Spaces_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Spaces_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie, was der Agent lesen und nutzen darf. Wenn er selbstständig oder in Ihren persönlichen Chats läuft, arbeitet er genau damit. In einem Projekt-Chat kommt Ihre Auswahl zu dem hinzu, was das Projekt bereits verknüpft. Wer ihn ausführt, braucht Zugriff auf alles, was Sie auswählen. Leer lassen, dann nutzt er dasselbe wie Sie.")
	return /** @type {LocalizedString} */ ("Pick what the agent may read and use. When it runs on its own or in your personal chats, it works with exactly that. In a project chat, your picks are added to what the project already links. Everyone who runs it needs access to each pick. Leave it empty and it uses the same things you would.")
});